import React from 'react';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';

const ValuePropositionSection = () => {
  const benefits = [
  {
    icon: 'TrendingUp',
    title: 'Accurate Valuations',
    description: 'Get precise fair market values based on real market data and comparable sales analysis.'
  },
  {
    icon: 'Clock',
    title: 'Save Time',
    description: 'Generate professional valuation reports in minutes, not hours or days.'
  },
  {
    icon: 'Shield',
    title: 'Industry Trusted',
    description: 'Insurance-grade reports accepted by lenders, insurers, and industry professionals.'
  },
  {
    icon: 'BarChart3',
    title: 'Market Insights',
    description: 'Access comprehensive market trends, depreciation curves, and days-on-market data.'
  }];


  const testimonials = [
  {
    name: 'Sarah Mitchell',
    role: 'Equipment Finance Manager',
    company: 'Capital Equipment Lending',
    avatar: "https://img.rocket.new/generatedImages/rocket_gen_img_1ae7d9bdc-1762274136565.png",
    avatarAlt: 'Professional headshot of woman with shoulder-length brown hair in navy blazer',
    quote: `CranePrice has transformed our lending process. We can now provide accurate valuations to our clients within minutes instead of waiting days for traditional appraisals.`
  },
  {
    name: 'Mike Rodriguez',
    role: 'Used Equipment Manager',
    company: 'Heavy Lift Solutions',
    avatar: "https://img.rocket.new/generatedImages/rocket_gen_img_1a05eed4a-1762274040165.png",
    avatarAlt: 'Professional headshot of Hispanic man with short black hair in dark suit',
    quote: `The inventory alerts have helped us identify underpriced equipment opportunities that we would have missed otherwise. ROI was immediate.`
  }];


  const stats = [
  { number: '50,000+', label: 'Crane Valuations Completed' },
  { number: '500+', label: 'Industry Professionals' },
  { number: '95%', label: 'Accuracy Rate' },
  { number: '24/7', label: 'Platform Availability' }];


  return (
    <div className="space-y-12">
      {/* Hero Section */}
      <div className="text-center">
        <h1 className="text-4xl font-bold text-text-primary mb-4">
          Join the Leading Crane Valuation Platform
        </h1>
        <p className="text-xl text-text-secondary max-w-2xl mx-auto">
          Get instant access to accurate crane valuations, market insights, and professional reports 
          trusted by dealers, lenders, and industry professionals worldwide.
        </p>
      </div>
      {/* Benefits Grid */}
      <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
        {benefits?.map((benefit, index) =>
        <div key={index} className="text-center p-6 bg-surface rounded-lg border border-border hover:shadow-md transition-shadow">
            <div className="w-12 h-12 bg-primary/10 rounded-lg flex items-center justify-center mx-auto mb-4">
              <Icon name={benefit?.icon} size={24} className="text-primary" />
            </div>
            <h3 className="text-lg font-semibold text-text-primary mb-2">{benefit?.title}</h3>
            <p className="text-sm text-text-secondary">{benefit?.description}</p>
          </div>
        )}
      </div>
      {/* Statistics */}
      <div className="bg-primary text-primary-foreground rounded-lg p-8">
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-6 text-center">
          {stats?.map((stat, index) =>
          <div key={index}>
              <div className="text-3xl font-bold mb-1">{stat?.number}</div>
              <div className="text-sm opacity-90">{stat?.label}</div>
            </div>
          )}
        </div>
      </div>
      {/* Testimonials */}
      <div>
        <h2 className="text-2xl font-bold text-text-primary text-center mb-8">
          Trusted by Industry Leaders
        </h2>
        <div className="grid md:grid-cols-2 gap-8">
          {testimonials?.map((testimonial, index) =>
          <div key={index} className="bg-surface border border-border rounded-lg p-6">
              <div className="flex items-start space-x-4">
                <div className="w-12 h-12 rounded-full overflow-hidden flex-shrink-0">
                  <Image
                  src={testimonial?.avatar}
                  alt={testimonial?.avatarAlt}
                  className="w-full h-full object-cover" />

                </div>
                <div className="flex-1">
                  <div className="flex items-center space-x-1 mb-2">
                    {[1, 2, 3, 4, 5]?.map((star) =>
                  <Icon key={star} name="Star" size={14} className="text-warning fill-current" />
                  )}
                  </div>
                  <p className="text-sm text-text-secondary mb-3 italic">
                    "{testimonial?.quote}"
                  </p>
                  <div>
                    <p className="font-medium text-text-primary">{testimonial?.name}</p>
                    <p className="text-sm text-text-secondary">
                      {testimonial?.role}, {testimonial?.company}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
      {/* Trust Indicators */}
      <div className="bg-muted rounded-lg p-6">
        <div className="flex flex-wrap items-center justify-center space-x-8 space-y-4">
          <div className="flex items-center space-x-2">
            <Icon name="Shield" size={20} className="text-success" />
            <span className="text-sm text-text-secondary">SSL Encrypted</span>
          </div>
          <div className="flex items-center space-x-2">
            <Icon name="Lock" size={20} className="text-success" />
            <span className="text-sm text-text-secondary">SOC 2 Compliant</span>
          </div>
          <div className="flex items-center space-x-2">
            <Icon name="Award" size={20} className="text-success" />
            <span className="text-sm text-text-secondary">Industry Certified</span>
          </div>
          <div className="flex items-center space-x-2">
            <Icon name="Users" size={20} className="text-success" />
            <span className="text-sm text-text-secondary">24/7 Support</span>
          </div>
        </div>
      </div>
    </div>);

};

export default ValuePropositionSection;